export default __webpack_public_path__ + "static/media/DMSans-Bold.65910454.woff2";